import Link from "next/link";
import S from "./index.module.scss";

const CustomizationSection = () => {
  return (
    <section className={S.customization}>
      <div className={S.content}>
        <h2 className={S.heading}>
          <span>Видите время</span>
          <span>по-своему?</span>
        </h2>
        <p className={S.description}>
          Индивидуальная кастомизация часов.
          <br />
          От уникальных конфигураций циферблата до полностью индивидуальных усложнений - ваше часовое видение
          приобретает форму.
        </p>
        <Link href="/configurator" className={S.button}>
          Начать кастомизацию
        </Link>
      </div>
    </section>
  );
};

export default CustomizationSection;
